import moment from "moment";
import i18n from "../i18n/i18n";

export const jsonToFormData = (jsonObj) =>
  Object.entries(jsonObj).reduce(
    (current, item) => (current.append(...item), current),
    new FormData()
  );

export const sendDataToReducer = (dispatch, type = null, payload = null) => {
  if (type) dispatch(type(payload));
};

export const formattedAmount = (amount = 0) => {
  const numericAmount = Number(amount);
  if (isNaN(numericAmount)) {
    return amount;
  }
  const fractionDigits = numericAmount % 1 === 0 ? 0 : 2;
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    minimumIntegerDigits: 1,
    useGrouping: true,
  });
  return `R ${formatter.format(numericAmount)}`;
};
// Generate random filename for uploads
export const getRandomFileName = (fileName) => {
  if (!fileName) return `${getRandomString(40)}.jpg`;
  const parts = fileName.split('.');
  const extension = parts.length > 1 ? parts.pop().toLowerCase() : 'jpg';
  return `${getRandomString(40)}.${extension}`;
};

// Helper to generate random strings
export const getRandomString = (length = 10) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
};

// Format file for FormData uploads (React Web)
export const getServerImageUploadFormat = (file, needRandomName = true) => {
  if (!file) return null;

  // `file` is expected to be a File object from an <input type="file">
  const originalName = file.name || 'unknown.jpg';
  const randomName = getRandomFileName(originalName);
  const fileName = needRandomName ? randomName : originalName;

  return new File([file], fileName, { type: file.type });
};

export const getValidDate = (
  date = null,
  format = "MM-DD-YYYY",
  getDateObject = false
) => {
  const validDate = date;
  if (getDateObject) return new Date(getValidDate(validDate, "YYYY/MM/DD"));
  if (moment(validDate).isValid()) {
    if (getDateObject) return validDate;
    return moment(validDate).format(format ?? "YYYY/MM/DD");
  }
  return null;
};
export const getDocFieldTranslationKey = () => {
  const locale = i18n.language
  switch (locale) {
      case 'en': return 'name';
      case 'ar': return 'arebic_name';
      case 'fr': return 'french_name';
      case 'de': return 'dutch_name';
      case 'es': return 'spanish_name';
      default: return 'name';
  }
}
export const getDocFieldTranslationKeyforDoc = () => {
  const locale = i18n.language
  switch (locale) {
      case 'en': return 'meta_key';
      case 'ar': return 'meta_key_arebic';
      case 'fr': return 'meta_key_french';
      case 'de': return 'meta_key_dutch';
      case 'es': return 'meta_key_spanish';
      default: return 'meta_key';
  }
}
export const getDocAttributeTranslationKey = () => {
  const locale = i18n.language
  switch (locale) {
      case 'en': return 'attribute_option';
      case 'ar': return 'attribute_option_arebic';
      case 'fr': return 'attribute_option_french';
      case 'de': return 'attribute_option_dutch';
      case 'es': return 'attribute_option_spanish';
      default: return 'name';
  }
}
